import styled from "styled-components";

import { Fonts } from "assets/fonts";
import { srOnly } from "ui/styles/style-snippets";

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ErrorMessage = styled.span<{ $align?: "right" | "left" }>`
  display: block;
  width: 100%;
  margin-top: 4px;
  ${Fonts.semiBold_12}
  color: ${(p) => p.theme.errorHighestContrast};
  text-align: ${(p) => p.$align || "right"};
`;

export const TextLabel = styled.span<{ $visible?: boolean }>`
  display: block;
  width: 100%;
  margin-bottom: 4px;
  ${Fonts.SEMIBOLD_12}
  color: ${(p) => p.theme.textMediumContrast};
  ${(p) => p.$visible !== undefined && !p.$visible && srOnly};
`;
